import React, {FC} from 'react';
import {TransactionGroupName, TransactionStatus} from '~/entities/transactions-history';
import warningMarkIcon from '~/shared/legacy_res/img/svg/warning-mark.svg';
import styles from './TransactionMessage.module.scss';

interface TransactionMessageProps {
    status: TransactionStatus;
    group: TransactionGroupName;
    message: string;
}

const TransactionMessage: FC<TransactionMessageProps> = ({status, group, message}) => {
    const getOperationName = () => {
        switch (group) {
            case 'incomings':
                return 'top-up';
            case 'outgoings':
                return 'withdrawal';
            default:
                return 'transaction';
        }
    };

    const getMessage = () => {
        switch (status) {
            case 'pending':
                return 'The exact amount will be calculated after executing the transaction on the network.';
            case 'moderate':
                return `Your ${getOperationName()} will be completed after a short compliance check.`;
            default:
                return message;
        }
    };

    const content = (
        <>
            <div className={styles.container}>
                <img src={warningMarkIcon} className={styles.icon} />
                <div className={styles.text}>{getMessage()}</div>
            </div>
        </>
    );
    return <>{getMessage() && content}</>;
};

export default TransactionMessage;
